import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import { MdEdit, MdOutlineDeleteForever} from "react-icons/md";
import { DestinationCrossBorderService } from "../../Services/DestinationCrossBorderService";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

export const CrossBorderList = () => {
  const [state,setState] = useState([])
  const [deleteModal,setDeleteModal] = useState({modal:false,id:null})
  const [loader,setLoader] = useState(false)
  const history = useHistory()

  const getDetail = async () => {
    setLoader(true);
    await DestinationCrossBorderService.getDestinationCrossBorderList().then((res) => {
      if (res.status) {
        setState(res.data);
        setLoader(false);
      }else{
        setLoader(false);
      }
    }).catch((err)=> {
      setLoader(false);
    })
  };

  const handleDelete = async () => {
    setLoader(true);
    const obj = {id: deleteModal.id};
    await DestinationCrossBorderService.deleteDestinationCrossBorder(obj).then((res) => {
      if (res.status) {
        setLoader(false);
        getDetail();
        toast.success(res.message);
        setDeleteModal({modal:false,id:null})
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <div style={{ width: "75%" }}>
      <div className="card">
        <div className="card-body">
          <div className="text-end mb-3">
            <Button
              type="button"
              className="btn btn-primary"
              onClick={()=> history.push("/add-cross-border")}
            >
              Add Cross Border Charges
            </Button>
          </div>
          <div className="table-responsive table-bordered">
            <table className="table table-striped table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th>S No.</th>
                  <th>Country</th>
                  <th>Silla border</th>
                  <th>Batha border</th>
                  <th>Final destination charge</th>
                  <th>Certificate of origin</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loader
                ? <tr><td colSpan={5} className="text-center"><Spinner animation="border" /></td></tr>
                : (state && Array.isArray(state) && state.length > 0)
                ? state?.map((item, key) => (
                    <tr key={key}>
                      <td className="text-body fw-bold">{(key + 1)}</td>
                      <td className="text-body align-top">{item?.country}</td>
                      <td className="text-body align-top">{item?.silla_border}</td>
                      <td className="text-body align-top">{item?.batha_border}</td>
                      <td className="text-body align-top">{item?.final_destination_charge}</td>
                      <td className="text-body align-top">{item?.certificate_of_origin}</td>
                      <td className="text-body">
                        <MdEdit
                          className="pointer"
                          onClick={()=> history.push(
                            "/edit-cross-border?id=" + item._id,
                            item
                          )}
                          style={{ fontSize: "22px", color: "rgb(3, 35, 254)" }}
                        />

                        <MdOutlineDeleteForever
                          className="pointer"
                          onClick={() => setDeleteModal({modal:true,id:item._id})}
                          style={{ fontSize: "22px", color: "red" }}
                        /> 
                      </td>
                    </tr>
                  ))
                : <tr><td colSpan={7} className="text-center">Data Not Available</td></tr>
                }
              </tbody>
            </table>
          </div>

          {/* {/ Delete Modal /} */}
          <Modal
            show={deleteModal.modal}
            onHide={() => setDeleteModal({modal:false,id:null})}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete Cross Border Charges</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h6>Are you sure want to delete cross border charges</h6>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setDeleteModal({modal:false,id:null})}>
                Close
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                {(loader && <Spinner animation="grow" size="sm" />) || "Delete"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};
